/* eslint-disable no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import { useDispatch } from "react-redux";
// import cardImage from "../../assets/images/mern.webp";
import {
  fetchUpdateBlog,
  likeBlog,
  saveUnsaveBlog
} from "../../features/blog/blogSlice";
import { addSavedBlog, removeSavedBlog } from "../../features/blogs/blogsSlice";

function DetailedBlog({ blog }) {
  const { image, title, tags, likes, description, isSaved } = blog;
  const dispatch = useDispatch();
  // console.log(id);

  const likeHandler = () => {
    const updatedData = { ...blog, likes: likes + 1 };
    // console.log(content);
    dispatch(fetchUpdateBlog({ updatedData }));
    dispatch(likeBlog());
  };
  const saveUnsaveHandler = () => {
    const updatedData = { ...blog, isSaved: !isSaved };
    // console.log(content);
    dispatch(fetchUpdateBlog({ updatedData }));
    dispatch(saveUnsaveBlog());
    if (isSaved) dispatch(removeSavedBlog());
    else dispatch(addSavedBlog());
  };
  return (
    <main className="post">
      <img
        src={image}
        alt="githum"
        className="w-full rounded-md"
        id="lws-megaThumb"
      />
      <div>
        <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
          {title}
        </h1>
        <div className="tags" id="lws-singleTags">
          <span>{tags.join(", ")}</span>
        </div>
        <div className="btn-group">
          {/* <!-- handle like on button click --> */}
          <button
            className="like-btn"
            id="lws-singleLinks"
            onClick={likeHandler}
          >
            <i className="fa-regular fa-thumbs-up"></i> {likes}
          </button>
          {/* <!-- handle save on button click --> */}
          {/* <!-- use ".active" class and "Saved" text  if a post is saved, other wise "Save" --> */}
          {isSaved === true ? (
            <button
              onClick={saveUnsaveHandler}
              className="active save-btn"
              id="lws-singleSavedBtn"
            >
              <i className="fa-regular fa-bookmark"></i> Saved
            </button>
          ) : (
            <button
              onClick={saveUnsaveHandler}
              className="save-btn"
              id="lws-singleSavedBtn"
            >
              <i className="fa-regular fa-bookmark"></i> Save
            </button>
          )}
        </div>
        <div className="mt-6">
          <p>{description}</p>
        </div>
      </div>
    </main>
  );
}

export default DetailedBlog;
